// extracted by mini-css-extract-plugin
export default {"Button":"install-extension-button__Button__tgqiE","BrowserIcon":"install-extension-button__BrowserIcon___q9lE"};